module.exports = __webpack_public_path__ + "kudos_55.svg?42dc62a709aeea52ac10756d33537d1b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_55.svg
// module id = 156
// module chunks = 0